/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable complexity */
import { FormSection, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath, isCanada, isMobileWeb, getDateObject } from '@tcp/core/src/utils';
import isEmpty from 'lodash/isEmpty';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from 'react';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import GiftServices from '@tcp/core/src/components/features/CnC/Checkout/organisms/ShippingPage/molecules/GiftServices';
import {
  SHIPPING_EXPRESS_FORM_VISIBLE,
  SPC_CUSTOM_DIMENSION_GROUP,
  SPC_TIMER,
} from '@tcp/core/src/constants/rum.constants';
import EddComponent from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent';
import WarningPrompt from '@tcp/core/src/components/features/CnC/Checkout/organisms/WarningPrompt';
import {
  hasGiftServiceError,
  hasRushShippingError,
  getSfsErroMessage,
  getSaveForLaterItemsOrderItemId,
  hasApoFpoError,
  getSaveForLaterItemsProductIds,
} from '@tcp/core/src/components/features/CnC/Checkout/util/utility';
import ApiTriggerTracker from '@tcp/core/src/utils/apiTriggerLogger';
import { STANDARD_EDD_CODE } from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/EddComponent.constants';
import GIFT_SERVICES_CONSTANTS from '@tcp/core/src/components/features/CnC/Checkout/organisms/ShippingPage/molecules/GiftServices/GiftServices.constants';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import CheckoutLabels from '@tcp/core/src/utils/labels/cnc/checkout.labels';

import { addEditAddressLabelsObj } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.labels.js';
import { SECTION_MODE, SPC_SECTION } from '../../container/SinglePageCheckout.constants';
import ShipmentMethods from '../../../common/molecules/SPCShipmentMethods';
import { setShippingFormValuesInSS } from '../../container/Shipping/Shipping.utils';
import ShippingPageLabels, {
  SHIPPING_LABELS,
} from '../../../Checkout/organisms/ShippingPage/views/ShippingPage.labels';
import AddressVerificationBadge from '../../../../../common/atoms/AddressVerificationBadge/views/AddressVerificationBadge';
import {
  getRangeDateText,
  getShipmentLabels,
  getShippingTitle,
} from '../../../common/molecules/SPCShipmentMethods/views/ShipmentMethods.view';

const SHIPPING_TEXT = 'Shipping';

const listenUpdateShipping = () => {
  try {
    const apiTriggerLoggerInstance = new ApiTriggerTracker();
    apiTriggerLoggerInstance.startListener('UPDATE_SHIPPING_DETAILS');
  } catch {
    console.error('apiTriggerLoggerInstance error with UPDATE_SHIPPING_DETAILS');
  }
};

const getSecondaryButtonType = (giftServiceError, rushShippingError, apoFpoError) => {
  let ctaType = 'shipingMethod';
  if (giftServiceError && !rushShippingError) {
    ctaType = 'giftservices';
  } else if (apoFpoError && !giftServiceError && !rushShippingError) {
    ctaType = 'shippingAddress';
  }
  return ctaType;
};

const renderShippingMethodErrors = ({
  sfsError,
  cartOrderItems,
  globalLabels,
  dispatchFormFieldChange,
  shipmentMethods,
  setSFSErrors,
  dispatchGiftFormFieldChange,
  addSFSItemsToSFL,
}) => {
  const checkoutLabels = getLabelFromCopyOrFromTranslation('checkout', CheckoutLabels);
  const standardShippingMethodsId = shipmentMethods?.find(
    (method) => method.code === STANDARD_EDD_CODE
  )?.id;

  const giftServiceError = sfsError && hasGiftServiceError(sfsError);
  const rushShippingError = sfsError && hasRushShippingError(sfsError);
  const apoFpoError = sfsError && hasApoFpoError(sfsError);
  if (giftServiceError || rushShippingError || apoFpoError) {
    const itemIds = getSaveForLaterItemsOrderItemId(sfsError) || [];
    const productIds = getSaveForLaterItemsProductIds(sfsError) || [];
    return (
      <WarningPrompt
        heading={renderLabel(
          checkoutLabels.shipping.lbl_sfs_cart_item_error,
          'lbl_sfs_cart_item_error'
        )}
        body={renderLabel(checkoutLabels.shipping[getSfsErroMessage(sfsError)])}
        type={getSecondaryButtonType(giftServiceError, rushShippingError, apoFpoError)}
        cartOrderItems={cartOrderItems}
        itemIds={itemIds}
        labels={globalLabels}
        saveForLaterAction={() => addSFSItemsToSFL(productIds)}
        secondaryCtaAction={() => {
          setSFSErrors(null);
          if (giftServiceError && !rushShippingError) {
            dispatchGiftFormFieldChange('hasGiftWrapping', false);
            dispatchGiftFormFieldChange(`message`, '');
          } else {
            dispatchFormFieldChange('shipmentMethods.shippingMethodId', standardShippingMethodsId);
          }
        }}
      />
    );
  }
  return null;
};

const getInitialValues = (props, shippingMethodId, fromShippingCollapsedSection) => {
  const {
    savedAddress: {
      id,
      addressId,
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      zipCode,
      city,
      state,
      phone: phoneNumber,
      phoneCountryCode,
      validationCode,
    },
    shipmentMethods,
  } = props;
  return {
    id,
    addressId,
    firstName,
    lastName,
    searchAddress: '',
    addressLine1,
    addressLine2,
    zipCode,
    city,
    state,
    country: isCanada() ? 'CA' : 'US',
    phoneNumber,
    shipmentMethods: { shippingMethodId: shippingMethodId || shipmentMethods?.[0]?.id },
    phoneCountryCode,
    ...(fromShippingCollapsedSection ? { validationCode } : {}),
  };
};
function ShippingCollapsed(props) {
  const {
    address = {},
    savedGiftService,
    selectedShipment,
    isLoginV2FlowEnabled,
    orderEddDates,
    shipmentMethods,
    isPlccIC,
    section,
    formName,
    selectedShipmentId,
    dispatchFormFieldChange,
    isLoadingShippingMethods,
    isUpdatingShipmentMethods,
    holidayMessageEnabled,
    isGiftServiceVisible,
    isGcEnabledOnBagSection,
    giftServicesInput,
    handleSaveAndContinueShipping,
    isShake,
    isSaveDisabled,
    saveBtnLoadingStatus,
    shouldShowShipmentMethodsCollapsed,
    sfsError,
    cartOrderItems,
    globalLabels,
    setSFSErrors,
    dispatchGiftFormFieldChange,
    addSFSItemsToSFL,
    dispatch,
    freeShippingThershold,
    shippingTotal,
    isDynamicFreeShippingEnabled,
    shipments,
    orderType,
    productTotal,
    loadShipmentMethods,
    savedAddress,
    isSmsSignedUp,
    isInternationalPhoneNumberEnabled,
    orderTrackingEnhancementEnabled,
    validateAddressWithMelissa,
    isAddressVerificationBadgeEnabled,
    contactFormData,
    updateSectionState,
    isShippingMethodsOnShippingEnabled,
    isShowShipmentMethodInCollapsed,
  } = props;
  const checkoutLabels = getLabelFromCopyOrFromTranslation('checkout', CheckoutLabels);
  const addEditAddressLabels = getLabelFromCopyOrFromTranslation(
    `global.addEditAddress`,
    addEditAddressLabelsObj
  );
  const shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);
  const {
    firstName = '',
    lastName = '',
    addressLine1 = '',
    addressLine2 = '',
    city = '',
    state = '',
    zipCode = '',
    phone = '',
    phoneCountryCode = '',
    validationCode,
  } = address;
  const { optionId, name, message = '' } = savedGiftService || {};

  const { lbl_holiday_date: holidayDateLbl } = getDynamicLabelValues('dynamic.cart');

  useEffect(() => {
    if ((isShippingMethodsOnShippingEnabled || holidayMessageEnabled) && (state || zipCode)) {
      loadShipmentMethods({
        state,
        zipCode,
        addressField1: addressLine1,
        addressField2: addressLine2,
        formName,
      });
    }
  }, [savedAddress]);

  const [currentShipmentId, setCurrentShipmentId] = useState(selectedShipmentId);

  useEffect(() => {
    if (isShowShipmentMethodInCollapsed && !isUpdatingShipmentMethods && sfsError) {
      dispatch(change('ShipmentMethods', `shipmentMethods.shippingMethodId`, selectedShipmentId));
      setCurrentShipmentId(selectedShipmentId);
    }
  }, [sfsError]);

  const shippingLabels = useMemo(() => getShipmentLabels(true), []);
  const { shippingMethodId: id, shippingSpeed, displayName } = selectedShipment || {};
  const titles = displayName?.replace(SHIPPING_TEXT, '');
  const title = getShippingTitle(shippingLabels, [titles], id);
  const rangeDateText = getRangeDateText(shippingSpeed);
  const submitSaveAndContinueGiftServices = (shipId) => {
    listenUpdateShipping();
    const shippingMethodId = shipId || currentShipmentId;
    setCurrentShipmentId(shippingMethodId);
    const values = getInitialValues(props, shippingMethodId);
    const shipMethods = { ...values.shipmentMethods, shippingMethodId };
    const updatedValues = orderTrackingEnhancementEnabled
      ? {
          ...values,
          shipmentMethods: shipMethods,
          smsSignUp: { sendOrderUpdate: isSmsSignedUp?.smsSignUp?.sendOrderUpdate },
        }
      : { ...values, shipmentMethods: shipMethods };
    if (
      giftServicesInput?.optionId?.search(GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_NONE_VALUE) !== -1
    ) {
      dispatch(change('GiftServices', `hasGiftWrapping`, false));
    } else {
      handleSaveAndContinueShipping({
        isExpanded: false,
        mode: SECTION_MODE.SECTION_VIEW_MODE,
        savedAddress: {
          ...updatedValues,
        },
        giftServicesDetails: { ...giftServicesInput },
      });
    }
  };

  const submitSaveAndContinueShipping = (shipId, fromShippingCollapsedSection) => {
    const shippingMethodId = shipId || currentShipmentId;
    setCurrentShipmentId(shippingMethodId);
    const values = getInitialValues(props, shippingMethodId, fromShippingCollapsedSection);
    const shipMethods = { ...values.shipmentMethods, shippingMethodId };
    const isSmsCheckboxChecked = contactFormData?.smsSignUp?.sendOrderUpdate;
    const updatedValues = orderTrackingEnhancementEnabled
      ? {
          ...values,
          shipmentMethods: shipMethods,
          smsSignUp: { sendOrderUpdate: isSmsCheckboxChecked },
        }
      : { ...values, shipmentMethods: shipMethods };
    const { phoneNumber } = updatedValues;
    handleSaveAndContinueShipping({
      isExpanded: false,
      mode: SECTION_MODE.SECTION_VIEW_MODE,
      savedAddress: {
        ...updatedValues,
      },
      giftServicesDetails: { ...giftServicesInput },
      fromShippingCollapsedSection,
    });
    setShippingFormValuesInSS({
      smsSignUp: { sendOrderUpdate: isSmsCheckboxChecked },
      phoneNumber,
    });
    updateSectionState({
      id: SPC_SECTION.SHIPPING,
      section: { smsSignUp: { sendOrderUpdate: isSmsCheckboxChecked }, phoneNumber },
    });
  };

  const buttonClick = () => {
    submitSaveAndContinueGiftServices();
  };

  const formatDate = (dt = '') => {
    if (dt?.includes('-')) {
      let [year, month, day] = dt.split('-');
      year = `${year}`;
      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;
      return [year, month, day];
    }

    const formattedDate = getDateObject(dt);
    const year = `${formattedDate.getFullYear()}`;
    let month = `${formattedDate.getMonth() + 1}`;
    let day = `${formattedDate.getDate()}`;
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    return [year, month, day];
  };

  const renderShippingOption = () => {
    const freeShipmentDate =
      orderEddDates?.maxDates?.UGNR && formatDate(orderEddDates?.maxDates?.UGNR);
    const holidayDate = formatDate(holidayDateLbl);
    const rushShipmentDate =
      orderEddDates?.maxDates?.U1DS && formatDate(orderEddDates?.maxDates?.U1DS);
    const rushShipmentDateExceptionState =
      orderEddDates?.maxDates?.U1AK && formatDate(orderEddDates?.maxDates?.U1AK);
    const expressShipmentDateExceptionState =
      orderEddDates?.maxDates?.U2AK && formatDate(orderEddDates?.maxDates?.U2AK);

    return (
      ((rushShipmentDate < holidayDate && rushShipmentDate[0] !== 'NaN') ||
        (rushShipmentDateExceptionState < holidayDate &&
          rushShipmentDateExceptionState[0] !== 'NaN')) &&
      ((holidayDate <= freeShipmentDate && freeShipmentDate[0] !== 'NaN') ||
        (holidayDate <= expressShipmentDateExceptionState &&
          expressShipmentDateExceptionState[0] !== 'NaN'))
    );
  };
  const colorStyle = 'green.500';
  const shouldRenderShippingOption = renderShippingOption();
  const isShipmentMethodEnabled =
    shouldShowShipmentMethodsCollapsed &&
    ((shouldRenderShippingOption && holidayMessageEnabled) || isShowShipmentMethodInCollapsed);
  const { hasGiftWrapping } = giftServicesInput || {};
  const shouldShowGiftServicesError = isGiftServiceVisible;
  const countryDialCode =
    isInternationalPhoneNumberEnabled && phoneCountryCode && phoneCountryCode !== '+1'
      ? `${phoneCountryCode} ${phone}`
      : phone;
  const giftServiceError = sfsError && hasGiftServiceError(sfsError);
  return (
    <BodyCopy component="div" className="spc-card-content">
      <BodyCopy component="div" className="elem-mb-XXS spc-card-content-fields">
        {`${firstName} ${lastName}`}
      </BodyCopy>
      <BodyCopy component="div" className="elem-mb-XXS spc-card-content-fields">
        <span>{addressLine1}</span>
        {isAddressVerificationBadgeEnabled && (
          <span>
            <AddressVerificationBadge
              validationCodes={validationCode}
              verifyFunction={validateAddressWithMelissa}
            />
          </span>
        )}
      </BodyCopy>
      {!isEmpty(addressLine2) ? (
        <BodyCopy component="div" className="elem-mb-XXS spc-card-content-fields">
          {addressLine2}
        </BodyCopy>
      ) : null}
      <BodyCopy component="div" className="spc-card-content-fields elem-mb-XS">
        {`${city ? `${city}, ` : ''}${state ? `${state} ` : ''}${zipCode}`}
      </BodyCopy>
      {isLoginV2FlowEnabled && phone && (
        <BodyCopy component="div" className="spc-card-content-fields elem-mb-XS">
          {`${countryDialCode}`}
        </BodyCopy>
      )}
      {!isShowShipmentMethodInCollapsed && selectedShipment?.code && (
        <BodyCopy component="div" className="elem-mb-XS">
          <EddComponent
            selectedShipment={selectedShipment?.code}
            isRangeDate
            spc
            myBagSpc
            textAlign="left"
            freeShippingThershold={freeShippingThershold}
            shippingTotal={shippingTotal}
            isDynamicFreeShippingEnabled={isDynamicFreeShippingEnabled}
            shipments={shipments}
          />
        </BodyCopy>
      )}

      {isShipmentMethodEnabled && !isEmpty(shipmentMethods) && !isPlccIC && (
        <Row fullBleed>
          <Col colSize={{ small: 6, medium: 8, large: 12 }}>
            <FormSection name="shipmentMethods">
              <ShipmentMethods
                shipmentMethods={shipmentMethods}
                shipmentMethodsSize={shipmentMethods?.length}
                formName={formName}
                formSection="shipmentMethods"
                selectedShipmentId={selectedShipmentId}
                shipmentHeader={renderLabel(
                  shippingPageLabels?.lbl_shipping_shipmentHeader,
                  'lbl_shipping_shipmentHeader'
                )}
                isLoadingShippingMethods={isLoadingShippingMethods}
                isUpdatingShipmentMethods={isUpdatingShipmentMethods}
                dispatchFormFieldChange={dispatchFormFieldChange}
                checkoutRoutingDone
                isEDD
                isEddABTest
                currentShipmentId={currentShipmentId}
                orderEddDates={orderEddDates}
                sectionMode={section?.mode}
                isShippingViewV2Flow
                submitSaveAndContinueShipping={submitSaveAndContinueShipping}
                fromShippingCollapsedSection={true}
                freeShippingThershold={freeShippingThershold}
                shippingTotal={shippingTotal}
                isDynamicFreeShippingEnabled={isDynamicFreeShippingEnabled}
                shipments={shipments}
                orderType={orderType}
                productTotal={productTotal}
                isShippingMethodsOnShippingEnabled={isShowShipmentMethodInCollapsed}
              />
            </FormSection>
          </Col>
        </Row>
      )}
      {optionId && !isGcEnabledOnBagSection && (
        <>
          <BodyCopy
            component="div"
            fontWeight="extrabold"
            className="elem-mb-XXS"
            fontFamily="secondary"
            fontSize="fs16"
          >
            {renderLabel(
              checkoutLabels.shipping.lbl_giftServices_header,
              'lbl_giftServices_header'
            )}
          </BodyCopy>
          <Row fullBleed className="spc-form-heading">
            <Image
              className="elem-pr-XS"
              width="12px"
              height="13px"
              src={getIconPath('gift-services')}
              alt="gift-services"
            />
            <BodyCopy
              component="div"
              className="elem-mt-XXXS"
              fontFamily="secondary"
              fontWeight="semibold"
              fontSize="fs14"
            >
              {name}
            </BodyCopy>
          </Row>
          <BodyCopy
            component="div"
            className="elem-mt-XXXS"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize="fs14"
          >
            {message}
          </BodyCopy>
        </>
      )}
      {!isGcEnabledOnBagSection && !savedGiftService?.optionId && !isCanada() && (
        <BodyCopy
          className="noGiftServices"
          fontWeight="semibold"
          fontFamily="secondary"
          text="text"
        >
          {renderLabel(
            checkoutLabels.shipping.lbl_no_gift_service_selected,
            'lbl_no_gift_service_selected'
          )}
        </BodyCopy>
      )}
      {!isShowShipmentMethodInCollapsed &&
        !savedGiftService?.optionId &&
        isCanada() &&
        isEmpty(orderEddDates?.maxDates) &&
        selectedShipment?.code && (
          <BodyCopy
            component="div"
            fontWeight="extrabold"
            className={'estimated-shipping-date free-standard-shipping'}
            fontFamily="secondary"
            fontSize="fs14"
          >
            {title}
          </BodyCopy>
        )}
      {!isShowShipmentMethodInCollapsed &&
        !savedGiftService?.optionId &&
        isCanada() &&
        isEmpty(orderEddDates?.maxDates) && (
          <BodyCopy
            component="span"
            fontWeight="bold"
            className="estimated-shipping-date"
            fontFamily="secondary"
            color={colorStyle}
          >
            {rangeDateText}
          </BodyCopy>
        )}
      {(isShipmentMethodEnabled ||
        (isGiftServiceVisible && !isPlccIC && !savedGiftService?.optionId && !isCanada())) && (
        <Row fullBleed>
          <Col colSize={{ small: 6, medium: 8, large: 12 }} className="isGiftServicesChecked">
            {!isShipmentMethodEnabled && (
              <GiftServices
                showDefaultCheckbox={false}
                formName="shippingForm"
                formSection="giftServices"
                variation="secondary"
                savedGiftService={savedGiftService}
                spc
                submitSaveAndContinueShipping={submitSaveAndContinueShipping}
              />
            )}
          </Col>
          {((hasGiftWrapping && shouldShowGiftServicesError) || isShipmentMethodEnabled) &&
            (!isGcEnabledOnBagSection || (isGcEnabledOnBagSection && !giftServiceError)) &&
            renderShippingMethodErrors({
              sfsError,
              cartOrderItems,
              globalLabels,
              dispatchFormFieldChange,
              shipmentMethods,
              setSFSErrors,
              dispatchGiftFormFieldChange,
              addSFSItemsToSFL,
            })}
          {!isShipmentMethodEnabled && hasGiftWrapping && !isMobileWeb() && (
            <Col colSize={{ small: 6, medium: 4, large: 4.5 }}>
              <Button
                type="submit"
                buttonVariation="fixed-width"
                fill="BLUE"
                className={`shipping-save-btn btn-border ${
                  isShake && !isSaveDisabled ? 'shake' : ''
                }`}
                disabled={false}
                onClick={buttonClick}
                loading={saveBtnLoadingStatus}
                spc
              >
                {renderLabel(
                  addEditAddressLabels.lbl_addEditAddress_saveAndContinue,
                  'lbl_addEditAddress_saveAndContinue'
                )}
              </Button>
            </Col>
          )}
        </Row>
      )}

      <RenderPerf.Measure
        name={SHIPPING_EXPRESS_FORM_VISIBLE}
        timerName={SPC_TIMER}
        cdGroup={SPC_CUSTOM_DIMENSION_GROUP}
      />
    </BodyCopy>
  );
}

ShippingCollapsed.propTypes = {
  address: PropTypes.shape({}),
  savedGiftService: PropTypes.shape({}),
  giftWrapOptions: PropTypes.shape({}),
  giftServicesLabels: PropTypes.shape({}).isRequired,
  selectedShipment: PropTypes.shape({}).isRequired,
  isLoginV2FlowEnabled: PropTypes.bool,
  orderEddDates: PropTypes.shape({}).isRequired,
  shouldShowShipmentMethodsCollapsed: PropTypes.bool,
};

ShippingCollapsed.defaultProps = {
  address: {},
  savedGiftService: {},
  giftWrapOptions: {},
  isLoginV2FlowEnabled: false,
  shouldShowShipmentMethodsCollapsed: false,
};

export default errorBoundary(
  connect()(
    reduxForm({
      form: 'ShipmentMethods',
      destroyOnUnmount: true,

      // a unique identifier for this form..
    })(ShippingCollapsed)
  )
);
